// Need to add a headers property so the fetch-interceptor can add the authorization header
export const addHeader = (init: RequestInit = {}): RequestInit => ({
  ...init,
  headers: {
    ...init.headers,
  },
});
